import React from "react";

class PayuForm extends React.Component {
  render() {
    const { payuResponse = {} } = this.props;
    return (
      <form
        autocomplete="off"
        id="payuForm"
        action={payuResponse["payuUrl"]}
        method="post"
        name="payuForm"
      >
        <input name="key" value={payuResponse["key"]} type="hidden" />
        <input name="hash" value={payuResponse["hash"]} type="hidden" />
        <input
          name="firstname"
          value={payuResponse["firstname"]}
          type="hidden"
        />
        <input name="lastname" value={payuResponse["lastname"]} type="hidden" />
        <input name="email" value={payuResponse["email"]} type="hidden" />
        <input name="phone" value={payuResponse["phone"]} type="hidden" />
        <input
          name="productinfo"
          value={payuResponse["productinfo"]}
          type="hidden"
        />
        <input name="txnid" value={payuResponse["txnid"]} type="hidden" />
        <input name="amount" value={payuResponse["amount"]} type="hidden" />

        <input name="surl" value={payuResponse["surl"]} type="hidden" />
        <input name="furl" value={payuResponse["furl"]} type="hidden" />
        <input name="curl" value={payuResponse["curl"]} type="hidden" />

        {/* <input name="bankcode" value={this.state.bankcode} type="hidden" />
        <input name="pg" value={this.state.paymentType} type="hidden" />
        <input name="ccname" value={this.state.card_name} type="hidden" />
        <input name="ccnum" value={this.state.card_number} type="hidden" />
        <input name="ccvv" value={this.state.card_cvv} type="hidden" />
        <input name="ccexpmon" value={this.state.card_mm} type="hidden" />
        <input name="ccexpyr" value={this.state.card_yyyy} type="hidden" /> */}
        <input name="udf1" value={payuResponse["udf1"]} type="hidden" />
        <input name="udf2" value={payuResponse["udf2"]} type="hidden" />
        <input name="udf3" value={payuResponse["udf3"]} type="hidden" />
        <input name="udf4" value={payuResponse["udf4"]} type="hidden" />
        <input name="udf5" value={payuResponse["udf5"]} type="hidden" />

        <input type="submit" value="Submit" type="hidden" />
      </form>
    );
  }
}

export default PayuForm;
